import { Switch } from '@/components/ui/switch'

interface SettingSwitchRowProps {
  id: string
  label: string
  description: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}

/**
 * One on/off setting: label and one-line description on the left, the switch
 * on the right, named by the label. The cookie banner and the Settings page's
 * Emails and Cookies tabs share it.
 */
export function SettingSwitchRow({
  id,
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
}: SettingSwitchRowProps) {
  return (
    <div className="flex items-start justify-between gap-4 py-3">
      <div>
        <p id={`${id}-label`} className="text-sm font-medium text-foreground">
          {label}
        </p>
        <p id={`${id}-hint`} className="text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-labelledby={`${id}-label`}
        aria-describedby={`${id}-hint`}
        className="mt-0.5 shrink-0"
      />
    </div>
  )
}
